import { Component, OnInit } from "@angular/core";
// import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserMgmtService } from "../user.service";

import { CommonService } from "../../../shared/common.service";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-couponlist",
  templateUrl: "./couponlist.component.html",
  styleUrls: ["./couponlist.component.css"],
})
export class CouponlistComponent implements OnInit {
  showCouponList: boolean;
  isLoading: boolean;

  total: any;
  couponList: any;
  couponId: any;
  userId: any;
  totalPage: number;
  pageLimit: number = 10;
  maxDate: any;

  minDate: any;

  currentPage: number = 0;
  searchStatus = "active";
  searchText1: string = "";
  searchStartDate: string;
  searchEndDate: string;
  offset: number;
  citySearch: any;
  searchText2: string;
  searchText3: string;
  searchBy: string;
  modalRef: any;

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private userService: UserMgmtService,
  
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
      if (param["userId"]) {
        this.userId = param["userId"];
        this.getCouponList();
        this.getUserList();
      }
    });
  }
  queryParams() {
    this.offset = this.pageLimit * this.currentPage;
    let query = "";
    query = query + "&limit=" + this.pageLimit + "&offset=" + this.offset;

    if (this.searchText1 && this.searchText1 !== "") {
      query = query + "&code=" + this.searchText1;
    }
    if (this.searchStatus == "disabled") {
      query = query + "&status=" + this.searchStatus;
    }
    if (this.searchStatus && this.searchStatus != "disabled") {
      query = query + "&status=" + this.searchStatus;
    }

    if (this.searchStartDate && this.searchStartDate != "") {
      // convert to epoch time
      let startDate = new Date(this.searchStartDate);
      query = query + "&startDate=" + Math.floor(startDate.getTime() / 1000);
    }
    if (this.searchEndDate && this.searchEndDate != "") {
      // convert to epoch time
      let endDate = new Date(this.searchEndDate);
      endDate.setDate(endDate.getDate() + 1);
      query = query + "&endDate=" + Math.floor(endDate.getTime() / 1000 - 1);
    }
    return query;
  }
  SetPage() {
    this.totalPage = 0;
    this.totalPage = this.total / this.pageLimit;
    this.totalPage = Math.ceil(this.totalPage);
    if (this.totalPage == 1 || this.total <= this.pageLimit) {
      this.totalPage = 1;
    }
  }
  changeEndDate() {
    this.maxDate = this.searchEndDate;
  }
  changeStartDate() {
    this.minDate = this.searchStartDate;
  }
  nextPage() {
    this.currentPage = this.currentPage + 1;
    this.getCouponList();
  }

  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.getCouponList();
  }
  changePageLimit() {
    this.currentPage = 0;
    this.getCouponList();
  }
  userList = [];
  getUserList() {
    let query = "userId=" + this.userId;
    this.userMgmtService.getUserListApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.userList = res["data"]["usersList"][0];
        } else {
          this.userList = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getCouponList() {
    let queryparams = this.queryParams();
    let query = "userId=" + this.userId + queryparams;
    this.showCouponList = false;
    this.isLoading = true;
    // this.isLoading = true;
    this.userService.getCouponListApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.total = res["data"].totalCount;
          // console.log(this.total);
          this.SetPage();
          this.couponList = res["data"]["coupon"];
          if (this.couponList.length > 0) {
            this.showCouponList = true;
          }
          this.couponList.forEach((element) => {
            if (element["status"] == "disabled") {
              element["disable"] = true;
            }
          });
          // console.log(this.userList)
        } else {
          this.couponList = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  activeIndex() {
    localStorage.setItem("activeIndex", "4");
  }

  onReset() {
    this.isLoading = true;
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.isLoading = false;
    }, 2000);
    (this.maxDate = ""),
      (this.minDate = ""),
      (this.searchStatus = "active"),
      (this.searchText1 = ""),
      (this.citySearch = ""),
      (this.searchText2 = ""),
      (this.searchText3 = ""),
      (this.searchBy = ""),
      (this.searchStartDate = ""),
      (this.searchEndDate = "");
    this.getCouponList();
  }
  searchFiltersBtn() {
    this.currentPage = 0;
    this.currentPage = 0;
    // this.searchfilter =  true;
    this.getCouponList();
  }

  deleteCoupon(couponId) {
    console.log(couponId._id, "rowwww");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this coupon " + couponId.code,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;

        this.userMgmtService.deleteCoupon(couponId._id).subscribe(
          (res) => {
            this.isLoading = false;
            if (res["message"] == "Success") {
              this._snackBar.open("Coupon deleted successfully!", "", {
                duration: 5000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
              // Swal.fire("Success", "Officer updated successfully!", "success");
              this.getCouponList();
            } else {
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }
    });
    history.pushState(null, "", null);
  }
  disabled: boolean = false;
  onIsHiddenChange(row) {
    console.log(row);
    let request = {
      couponId: row._id,
      disable: row.disable,
    };
    this.userMgmtService.updateCoupon(request).subscribe(
      (data) => {
        this.isLoading = false;
        if ((data["message"] = "Success")) {
          this._snackBar.open("Coupon updated successfully!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          this.getCouponList();
        } else {
          Swal.fire("Error", data.data, "error");
        }
      },
      (err) => {
        this.isLoading = false;
        Swal.fire("Error", err.error.data, "error");
        this.modalRef.close();
        this.getCouponList();
      }
    );
  }
}
